import { TranslationsTypes } from './translation.model';

export interface IVaultPasswordDTO {
    Id: string;
    DisplayName: string;
    VaultId: string;
    FolderId: string;
    PasswordType: string;
    Username: string;
    Description: string;
    FailedSync: boolean;
}

export interface VaultPasswordAddEdit {
    '@odata.type': string;
    VaultId: string;
    FolderId: string;
    DisplayName: string;
    Description: string;
    DaysToExpire: number;
    ExpireAfterXMinutes: number;
    EnableTrustedThirdPartyAccess: boolean;
    PasswordType: string;
    Username: string;
    Password: string;
    Notes: string;
    IgnoreVaultPasswordPolicy: boolean;
    Domain: string;
    MachineName: string;
    WebsiteUrl: string;
    Complexity: string;
    IconUrl: string;
    DBType: string;
    DBTypeOther: string;
    SnmpCommunityString: string;
    SnmpAgentPort: number;
    SnmpAuthenticationProfile: string;
    SnmpEncryptionProtocol: string;
    SnmpUser: string;
    SnmpAuthenticationPassword: string;
    SnmpPrivacyPassword: string;
    AgentProfileId: null | string;
    [propName: string]: any;
}

export interface VaultPassword {
    '@odata.context': string;
    Id: string;
    Created: Date;
    CreatedBy: string;
    LastModified: Date;
    LastModifiedBy: string;
    FolderId: string;
    VaultId: string;
    Password: string;
    DisplayName: string;
    Description?: string;
    IconUrl?: any;
    PasswordType: string;
    Complexity: string;
    MachineName: string;
    Domain: string;
    DaysToExpire: number;
    ExpireAfterXMinutes: number;
    EnableTrustedThirdPartyAccess: boolean;
    Username: string;
    WebsiteUrl?: string;
    IgnoreVaultPasswordPolicy: boolean;
    Notes?: string;
    AgentProfileId?: string;
    DBType?: string;
    DBTypeOther?: string;
    SnmpAuthenticationPassword?: string;
    SnmpPrivacyPassword?: string;
    SnmpCommunityString?: string;
    SnmpAgentPort?: number;
    SnmpAuthenticationProfile?: string;
    SnmpEncryptionProtocol?: string;
    SnmpUser?: string;
    PasswordLastModified: Date;
    PasswordLastModified2?: Date;
}

export interface IPasswordDetailsNoPwd {
    Id: string;
    VaultId: string;
    FolderId: string;
    DisplayName: string;
    PasswordType: string;
    Domain: string;
    MachineName: string;
    WebsiteUrl: string;
    Username: string;
    Description: string;
    Notes: string;
    DBType: string;
    DBTypeOther: string;
    SnmpCommunityString: string;
    SnmpAgentPort: string;
    SnmpAuthenticationProfile: string;
    SnmpEncryptionProtocol: string;
    SnmpUser: string;
    SnmpAuthenticationPassword: string;
    SnmpPrivacyPassword: string;
    AgentProfileId: string;
    ExpireAfterXMinutes: number;
    EnableTrustedThirdPartyAccess: boolean;
    FolderName: string;
}

export interface IPasswordReminders {
    Id: string;
    PasswordName: string;
    VaultName: string;
    FolderId: string;
    FolderName: string;
    PasswordType: string;
    RevealedAt: Date;
    RevealedAt2: Date;
    ExpireAt: Date;
    ExpireAt2: Date;
    OrganizationId: string;
    VaultId: string;
    VaultPasswordId: string;
    AgentProfileId: string;
    FailedSync: boolean;
    Reason: VaultPasswordExpireReason;
}

export interface IPasswordTypeUIDetails {
    passwordTypeForDisplay: TranslationsTypes;
    passwordTypeImage: string;
}

export interface VaultPasswordDisplayFields {
    ShowPassword: boolean;
    ShowUsername: boolean;
    ShowDomain: boolean;
    ShowWebsiteUrl: boolean;
    ShowMachineName: boolean;
    ShowDBTypes: boolean;
    ShowDBOther: boolean;
    ShowSnmpCommunityString: boolean;
    ShowSnmpAuthenticationProfile: boolean;
    ShowSnmpEncryptionProtocol: boolean;
    ShowSnmpUser: boolean;
    ShowSnmpAuthenticationPassword: boolean;
    ShowSnmpPrivacyPassword: boolean;
    ShowSnmpAgentPort: boolean;
    ShowThirdPartyAgentsOnly: boolean;
    ShowSyncAgent: boolean;
    ShowDisabledAgent: boolean;
}

export interface IVaultPasswordUrl {
    Username: string;
    VaultId: string;
    VaultPasswordId: string;
    WebsiteUrl: string;
}

export enum VaultPasswordExpireReason {
    Expired = 'Expired',
    Revealed = 'Revealed',
    Compromised = 'Compromised'
}
